var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-specs"},[_c('div',{staticClass:"base-specs__list"},[(_vm.head)?_c('div',{staticClass:"base-specs__item base-specs__item--head"},[_vm._v(" "+_vm._s(_vm.head)+" ")]):_vm._e(),_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"base-specs__item"},[_vm._v(" "+_vm._s(item)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }